<script setup lang="ts">
import { ref, onMounted } from "vue";

const props = defineProps({
  msg: {
    type: String,
    required: true
  }
});

// Interface for the table data items
interface TableItem {
  column1: string;
  column2: string;
  column3: string;
  column4: string;
  column5: string;
  column6: string;
}

// State management for loading and table data
const isLoading = ref(true);
const tableData = ref<TableItem[]>([]);

// Simulating data fetching
onMounted(() => {
  setTimeout(() => {
    tableData.value = [
      {
        column1: "Data 1",
        column2: "Data 2",
        column3: "Data 3",
        column4: "Data 3",
        column5: "Data 3",
        column6: "Data 3"
      },
      {
        column1: "Data A",
        column2: "Data B",
        column3: "Data C",
        column4: "Data 3",
        column5: "Data 3",
        column6: "Data 3"
      },
      {
        column1: "Data A",
        column2: "Data B",
        column3: "Data C",
        column4: "Data 3",
        column5: "Data 3",
        column6: "Data 3"
      }
    ];
    isLoading.value = false;
  }, 2000); // Simulating a 2-second delay for loading
});
</script>

<template>
  <div class="spacer"></div>
  <div>{{ props.msg }}</div>
  <div class="">
    <div class="button-top-margin-15px">
      <div class="shimmer button-top-margin-15px" :style="{ width: '40%', height: '20px' }"></div>
    </div>
    <div class="item-inline">
      <div class="item-inline button-top-margin-15px" :style="{ width: '90%', height: '20px' }">
        <div class="shimmer" :style="{ width: '100%', height: '20px' }"></div>
      </div>
      <div :style="{ width: '30%' }"></div>
      <div class="item-inline button-top-margin-15px" :style="{ width: '100%', height: '20px' }">
        <div class="shimmer" :style="{ width: '20%', height: '20px' }"></div>
        <div class="shimmer" :style="{ width: '20%', height: '20px' }"></div>
        <div class="shimmer" :style="{ width: '60%', height: '20px' }"></div>
      </div>
    </div>
  </div>
  <div class="button-top-margin-15px"></div>
  <table class="table">
    <thead>
      <tr>
        <th><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></th>
        <th><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></th>
        <th><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></th>
        <th><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></th>
        <th><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></th>
        <th><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></th>
      </tr>
    </thead>
    <tbody>
      <!-- Display shimmer rows while loading -->
      <tr v-for="i in 1" :key="i">
        <td><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></td>
        <td><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></td>
        <td><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></td>
        <td><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></td>
        <td><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></td>
        <td><div class="shimmer" :style="{ width: '100%', height: '20px' }"></div></td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
/* Table Styles */
.table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 10px;
  border: 1px solid var(--mds_brand_appearance_neutral_weak_background-color);
  text-align: left;
  background-color: #f6f7f8;
}

/* Shimmer Effect Styles */
.shimmer {
  background-color: #f6f7f8;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    var(--mds_brand_appearance_neutral_weak_background-color) 25%,
    var(--mds_brand_appearance_neutral_weakest_background-color) 50%,
    var(--mds_brand_appearance_neutral_strong_background-color) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
